import type { GeoPoint } from 'api/generated/transportOrdersApi';

const toDegreesMinutesSeconds = (value: number) => {
    const totalTenths = Math.round(Math.abs(value) * 36_000);
    const tenths = totalTenths % 10;
    const totalSeconds = (totalTenths - tenths) / 10;
    const seconds = totalSeconds % 60;
    const totalMinutes = (totalSeconds - seconds) / 60;
    const minutes = totalMinutes % 60;

    return { degrees: (totalMinutes - minutes) / 60, minutes, seconds, tenths };
};

const pad = (value: number) => String(value).padStart(2, '0');

const formatAxis = (value: number, positive: string, negative: string) => {
    const { degrees, minutes, seconds, tenths } = toDegreesMinutesSeconds(value);

    return `${degrees}°${pad(minutes)}'${pad(seconds)}.${tenths}"${value < 0 ? negative : positive}`;
};

export const formatCoordinates = ({ latitude, longitude }: GeoPoint) =>
    `${formatAxis(latitude, 'N', 'S')} ${formatAxis(longitude, 'E', 'W')}`;
